import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import customerActions from '../../../Actions/customerActions'
import eventsActions from '../../../Actions/InternalCustomerAdmin/eventsActions';
import subscriptionActions from '../../../Actions/Voss/subscriptionActions'
import { ToggleCard } from "../../../Components/Card/ToggleCard";
import Subscriptions from "../../../Components/Customer/VOSS/Subscriptions/Subscriptions";
import InactiveSubscriptions from '../../../Components/Customer/VOSS/Subscriptions/InactiveSubscriptions';
import { VossSubscriptionItemStatus } from '../../../Constants/VOSS/vossSubscriptionItemStatus';
import useModal from '../../../Hooks/useModal';
import Modals from '../../../Constants/modals';
import RepublishEventModal from '../../../Components/Modals/RepublishEventModal/RepublishEventModal';
import ReactivateSubscriptionModal from '../../../Components/Modals/ReactivateSubscription/ReactivateSubscriptionModal';
import { useTranslation } from 'react-i18next';

const SubscriptionContainer = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [detailedSubscriptions, setDetailedSubscriptions] = useState([]);
    const [republishContext, setRepublishContext] = useState(null);
    const [reactivateContext, setReactivateContext] = useState(null);

    const customer = useSelector(state => state.CustomerReducer.customer);
    const subscriptions = useSelector(state => state.CustomerReducer.subscriptions);
    const detailedSubscriptionsBulk = useSelector(state => state.CustomerReducer.detailedSubscriptions);
    const dataLoading = useSelector(state => state.CommonReducer.dataLoading.subscriptions);
    const isRepublishing = useSelector(state => state.CommonReducer.dataLoading.resendCustomerEvent);
    const isReactivating = useSelector(state => state.CommonReducer.dataLoading.reactivateSubscription);
    const vonAccounts = useSelector(state => state.CustomerReducer.vonAccounts);
    const user = useSelector(state => state.CommonReducer.user);

    const { openModal, closeModal, isModalOpen } = useModal();

    const fetchDetailedSubscription = (subscription) => {
        if (!detailedSubscriptions[subscription.id]) {
            dispatch(subscriptionActions.getSubscription(subscription.id, null, (s) => {
                setDetailedSubscriptions(prev => ({ ...prev, [subscription.id]: s }));
            }));
        }
    };

    useEffect(() => {
        if (customer.vossCustomer && !subscriptions)
            dispatch(customerActions.searchSubscriptions(customer.vossCustomer.id));

        if (customer.vossCustomer && !detailedSubscriptionsBulk)
            dispatch(customerActions.getDetailedSubscriptions(customer.vossCustomer.id));

        if ((customer.vossCustomer) && !vonAccounts)
            dispatch(customerActions.getVonAccounts(customer.vonCustomer?.id ?? customer.vossCustomer.id));
    }, []);

    const handleRepublishEvent = (product) => {
        setRepublishContext(product);
        openModal(Modals.RepublishEventModal);
    };

    const confirmRepublishEvent = () => {
        if (republishContext && !isRepublishing) {
            dispatch(eventsActions.resendApplicationAddedToCustomer(
                customer.vossCustomer.id,
                republishContext.productFamilyId,
                () => {
                    closeModal();
                    setRepublishContext(null);
                }
            ));
        }
    };

    const handleReactivateSubscription = (subscription) => {
        setReactivateContext(subscription);
        openModal(Modals.ReactivateSubscriptionModal);
    };

    const confirmReactivateSubscription = () => {
        if (reactivateContext && !isReactivating) {
            dispatch(subscriptionActions.reactivateSubscription(reactivateContext.id, () => {
                closeModal();
                setReactivateContext(null);
                dispatch(customerActions.searchSubscriptions(customer.vossCustomer.id));
            }));
        }
    };

    const options = [
        {
            title: "subscriptioncard.activesubscriptions",
            content: <Subscriptions subscriptions={subscriptions?.filter((sub) => sub.status === VossSubscriptionItemStatus.Active)} customer={customer} vonAccounts={vonAccounts} user={user} detailedSubscriptions={detailedSubscriptionsBulk} fetchDetailedSubscription={fetchDetailedSubscription} handleRepublishEvent={handleRepublishEvent} />
        },
        {
            title: "subscriptioncard.inactivesubscriptions",
            content: <InactiveSubscriptions subscriptions={subscriptions?.filter((sub) => sub.status === VossSubscriptionItemStatus.Terminated)} detailedSubscriptions={detailedSubscriptions} fetchDetailedSubscription={fetchDetailedSubscription} onReactivate={handleReactivateSubscription} />
        }
    ];

    return (
        <>
            <ToggleCard title="subscriptionscontainer.header" options={options} isLoading={dataLoading} />
            {isModalOpen(Modals.RepublishEventModal) && (
                <RepublishEventModal
                    title={t('republishEventModal.title')}
                    description={t('republishEventModal.description')}
                    onConfirm={confirmRepublishEvent}
                    isLoading={isRepublishing}
                />
            )}
            {isModalOpen(Modals.ReactivateSubscriptionModal) && (
                <ReactivateSubscriptionModal
                    subscription={reactivateContext}
                    onConfirm={confirmReactivateSubscription}
                    isLoading={isReactivating}
                />
            )}
        </>
    );
}

export default SubscriptionContainer;